import useUiFactory from '@/composables/ui/uiFactory'
import useAppState from '@/composables/ui/ui'

export default function useContextChangeVars() {
  const { removeRespondHash } = useUiFactory()
  const { postIdToShow, lastSavedPost } = useAppState()

  function contextChange() {
    removeRespondHash()
    postIdToShow.value = null
    lastSavedPost.value = null
  }

  return {
    contextChange,
  }
}
